export default __webpack_public_path__ + "static/media/1128040325514237.4f318a55.jpg";